import React, { useState, useEffect } from 'react';
import { Container, Row, Col, InputGroup } from 'react-bootstrap';
import { axiosInstance } from '../../../../../api/axios';
import { HttpSuccessCodes } from '../../../../errorhandling/HttpErrorCodes';
import FilterModal from '../../../../components/common/filter-modal/FilterModal';
import { SearchSVG } from '../../../../img/GlobalSVG';
import TextInput from '../../../../../Components/GenericInputText/TextInput';
import APIEndpoints from '../../../../api/APIEndpoints';
import Lists from '../lists';
import Skeleton from 'src/Member/components/footer/Skeleton';
import AddButton from '../../UserFormNew/components/AddButton';

const EmployerPanel = ({
  onSelectedEmpHandler,
  blobOid,
  employerAllData,
  setEmployerAllData,
  selectedEmployerData,
  showEmployerOnly,
  onUnSelectedEmpHandler,
  //selectedLocation,
  //setSelectedLocation,
  editAffiliatedRecords,
}) => {
  const cacheBuster = (url) => `${url}?cb=${Date.now()}`;

  const [openEmployerMOdal, setOpenEmployerMOdal] = useState(false);
  const [employerData, setEmployerData] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [loadingPage, setLoadingPage] = useState(true);
  const [customError, setCustomError] = useState(false);
  const [searched, setSearched] = useState([]);
  const [searchedData, setSearchedData] = useState([]);
  let flag = false;

  //useEffect( () => {
  //setEmployerData( employerAllData );
  //}, [] );

  const onChangeEmployerHandler = (e) => {
    setSearchString(e.target.value);
    const tempBlob2 = employerData.filter(
      (emp) =>
        emp?.ClientId?.toLowerCase().includes(e.target.value.toLowerCase()) ||
        emp?.ClientName?.toLowerCase().includes(e.target.value.toLowerCase()),
    );
    setSearchedData(tempBlob2);
    tempBlob2.map((emp) => {
      if (emp.isChecked === true) {
        return;
      } else {
        flag = true;
      }
    });
    if (!flag) {
      setSearched(tempBlob2);
    } else {
      setSearched([]);
    }
  };

  const handleAddEmployer = (e, blobId) => {
    console.log('calling this');
    e.stopPropagation();
    setOpenEmployerMOdal(true);
    setEmployerData([]);
    getEmployerData(blobId);
    setSearched([]);
  };

  const applyFilterHandler = (e) => {
    if (employerData && employerData.length > 0 && blobOid) {
      const empAllObj = { [employerData[0].BlkOfBusOid]: employerData };
      let tempObj = { ...employerAllData };
      tempObj = Object.assign(tempObj, empAllObj);
      setEmployerAllData(tempObj);
    }
    if (!blobOid && employerData) {
      console.log(
        'all employer data when no Blob is passed on....',
        employerData,
      );
      setEmployerAllData(employerData);
    }
    const selectedEmployer = employerData.filter(
      (emp) => emp.isChecked == true,
    );
    const unSelectedEmployer = employerData.filter(
      (emp) => emp.isChecked == false,
    );
    //console.log(typeof onUnSelectedEmpHandler)
    onSelectedEmpHandler(selectedEmployer, blobOid);
    //unSelectedEmployer && unSelectedEmployer.length > 0 && onUnSelectedEmpHandler(unSelectedEmployer);
    //console.log('unSelectedEmployer', unSelectedEmployer, typeof onUnSelectedEmpHandler);
    if (unSelectedEmployer && unSelectedEmployer.length > 0) {
      /*unSelectedEmployer.forEach(e => {
        console.log('selectedLocation', employerAllData, selectedLocation, e);
      })*/
      onUnSelectedEmpHandler(unSelectedEmployer);
    }
    /*
    if ( selectedLocation && selectedLocation.hasOwnProperty( clientOid ) ) {
      const tempObj = { ...selectedLocation };
      delete tempObj[ clientOid ];
      setSelectedLocation( tempObj );
    }
    */

    setOpenEmployerMOdal(false);
    setSearchString('');
  };

  const selectChangeHandler = (e) => {
    e.stopPropagation();
    const { name, checked } = e.target;
    if (name === 'select-all-employer') {
      if (searchString === '') {
        const tempEmp = employerData.map((emp) => {
          return { ...emp, isChecked: checked };
        });
        setEmployerData(tempEmp);
      } else {
        const tempEmp = employerData.map((emp) =>
          emp?.ClientId?.toLowerCase().includes(searchString.toLowerCase()) ||
          emp?.ClientName?.toLowerCase().includes(searchString.toLowerCase())
            ? { ...emp, isChecked: checked }
            : emp,
        );
        const data = tempEmp.filter((emp) => emp.isChecked === true);
        setSearched(data);
        setEmployerData(tempEmp);
      }
    } else {
      if (searchString === '') {
        const tempEmp = employerData.map((emp) =>
          emp.ClientId === name ? { ...emp, isChecked: checked } : emp,
        );
        setEmployerData(tempEmp);
      } else {
        const tempEmp2 = employerData.map((emp) =>
          emp?.ClientId?.toLowerCase().includes(searchString.toLowerCase()) ||
          emp?.ClientName?.toLowerCase().includes(searchString.toLowerCase())
            ? emp.ClientId === name
              ? { ...emp, isChecked: checked }
              : emp
            : emp,
        );
        const tempEmp = tempEmp2.filter(
          (emp) =>
            emp?.ClientId?.toLowerCase().includes(searchString.toLowerCase()) ||
            emp?.ClientName?.toLowerCase().includes(searchString.toLowerCase()),
        );
        //const tempBlob1 = tempBlob.map( blob => blob.BlkOfBusId === name ? { ...blob, isChecked: checked } : blob );
        tempEmp.map((emp) => {
          if (emp.isChecked === true) {
            return;
          } else {
            flag = true;
          }
        });
        if (!flag) {
          setSearched(tempEmp);
        } else {
          setSearched([]);
        }
        setEmployerData(tempEmp2);
      }
    }
  };

  const getEmployerData = async (blobId) => {
    try {
      //setLoadingPage( true );
      let employerSelectedData = [employerAllData]
        .map((item) => item[blobId] || null)
        .filter((e1) => e1 !== null);

      if (!blobId) {
        //employerSelectedData = employerAllData.filter( e => e.isChecked === true );
        employerSelectedData = employerAllData;
      }

      if (employerSelectedData.length > 0) {
        setLoadingPage(false);
        setCustomError(false);
        if (blobId) {
          setEmployerData(employerSelectedData[0]);
        }
        if (!blobId) {
          setEmployerData(employerSelectedData);
        }
      } else {
        let apiUrl = APIEndpoints.getEmployerListResources() + 'pagesize/5000/';
        if (blobId) {
          apiUrl = apiUrl + 'blkofbusoid/' + blobId;
        }
        const EmployerListResponse = await axiosInstance.get(
          cacheBuster(apiUrl),
        );
        if (
          EmployerListResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200
        ) {
          setLoadingPage(false);
          setCustomError(false);

          if (EmployerListResponse?.data?.Response?.Client) {
            if (
              selectedEmployerData &&
              selectedEmployerData[blobId] &&
              selectedEmployerData[blobId].length > 0
            ) {
              const employerList = EmployerListResponse?.data?.Response?.Client;
              const tempObj = employerList.map((item) =>
                selectedEmployerData[blobId].filter((selectedItem) =>
                  Boolean(selectedItem.ClientId === item.ClientId),
                ).length
                  ? { ...item, isChecked: true }
                  : item,
              );
              setEmployerData(tempObj);
            } else if (
              selectedEmployerData &&
              !selectedEmployerData[blobId] &&
              selectedEmployerData.length > 0
            ) {
              const employerList = EmployerListResponse?.data?.Response?.Client;
              const tempObj = employerList.map((item) =>
                selectedEmployerData.filter((selectedItem) =>
                  Boolean(selectedItem.ClientId === item.ClientId),
                ).length
                  ? { ...item, isChecked: true }
                  : item,
              );
              setEmployerData(tempObj);
            } else {
              setEmployerData(EmployerListResponse?.data?.Response?.Client);
            }
          }
        }
      }
    } catch (error) {
      setLoadingPage(false);
      setCustomError(true);
      setEmployerData([]);
    }
  };
  return (
    <>
      {blobOid ? (
        editAffiliatedRecords ? (
          <button
            type="button"
            className="panel-card-link"
            onClick={(e) => handleAddEmployer(e, blobOid)}
          >
            Select Employer(s)
          </button>
        ) : (
          <button
            type="button"
            className="panel-card-link panel-card-link-disable"
          >
            Select Employer(s)
          </button>
        )
      ) : null}
      {!blobOid ? (
        editAffiliatedRecords ? (
          <AddButton
            onClick={(e) => handleAddEmployer(e, blobOid)}
            label={'Select Employer(s)'}
            className={'add-button-active'}
          />
        ) : (
          <AddButton
            label={'Select Employer(s)'}
            className={'add-button-disable'}
          />
        )
      ) : null}

      <FilterModal
        showBackButton={false}
        isVisible={openEmployerMOdal}
        onHide={() => {
          setSearchString('');
          setOpenEmployerMOdal(false);
          setCustomError(false);
          setLoadingPage(true);
        }}
        applyFilterHandler={applyFilterHandler}
        showCancel={true}
        titleLabel="Employer(s)"
        showApply={true}
        showApplyLabel="Add Selected"
      >
        {loadingPage && !customError && <Skeleton count={10} />}

        {!loadingPage &&
          !customError &&
          employerData &&
          Object.keys(employerData).length > 0 && (
            <Container className="mt-3 mb-3">
              <Row>
                <Col sm={12}>
                  <div>
                    <TextInput
                      parentClassName="mb-2"
                      label="Employer"
                      append={
                        <InputGroup.Text>
                          <SearchSVG.SearchSVG className="primary-text-color" />
                        </InputGroup.Text>
                      }
                      inputProps={{
                        type: 'text',
                        placeholder: 'Search by name or Employer ID',
                        value: searchString,
                        onChange: onChangeEmployerHandler,
                        className: 'border-right-0',
                        autoFocus: false,
                        id: 'filter-broker-input',
                      }}
                    />
                  </div>
                </Col>
              </Row>
              {searchString === '' ? (
                <>
                  <Row>
                    <Col sm={12} className="mt-4 mb-2">
                      <div className=" select-all-row d-flex">
                        <input
                          type="checkbox"
                          id="select-all-employer"
                          name="select-all-employer"
                          className="p-0 mt-auto mb-auto"
                          onChange={(e) => {
                            selectChangeHandler(e);
                          }}
                          checked={
                            searchString === ''
                              ? employerData.filter(
                                  (emp) => emp.isChecked !== true,
                                ).length < 1
                              : searched && searched.length > 0
                              ? searched.filter((emp) => emp.isChecked !== true)
                                  .length < 1
                              : employerData.filter(
                                  (emp) => emp.isChecked !== true,
                                ).length < 1
                          }
                        />
                        <label
                          className="my-auto select-all-checkbox"
                          htmlFor="select-all-employer"
                        >
                          Select All
                        </label>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} className="mb-1">
                      <Lists
                        data={employerData}
                        selectChangeHandler={selectChangeHandler}
                        displayId="ClientId"
                        displayLabel="ClientName"
                        labelIdText="Employer ID"
                        searchString={searchString}
                      />
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  {searchedData && Object.keys(searchedData).length ? (
                    <>
                      <Row>
                        <Col sm={12} className="mt-4 mb-2">
                          <div className=" select-all-row d-flex">
                            <input
                              type="checkbox"
                              id="select-all-employer"
                              name="select-all-employer"
                              className="p-0 mt-auto mb-auto"
                              onChange={(e) => {
                                selectChangeHandler(e);
                              }}
                              checked={
                                searchString === ''
                                  ? employerData.filter(
                                      (emp) => emp.isChecked !== true,
                                    ).length < 1
                                  : searched && searched.length > 0
                                  ? searched.filter(
                                      (emp) => emp.isChecked !== true,
                                    ).length < 1
                                  : employerData.filter(
                                      (emp) => emp.isChecked !== true,
                                    ).length < 1
                              }
                            />
                            <label
                              className="my-auto select-all-checkbox"
                              htmlFor="select-all-employer"
                            >
                              Select All
                            </label>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12} className="mb-1">
                          <Lists
                            data={employerData}
                            selectChangeHandler={selectChangeHandler}
                            displayId="ClientId"
                            displayLabel="ClientName"
                            labelIdText="Employer ID"
                            searchString={searchString}
                          />
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <Container className="mt-3 mb-3">
                      <div>No Records Found</div>
                    </Container>
                  )}
                </>
              )}
            </Container>
          )}
        {!loadingPage &&
          customError &&
          employerData &&
          Object.keys(employerData).length == 0 && (
            <Container className="mt-3 mb-3">
              <div>No Records Found</div>
            </Container>
          )}
      </FilterModal>
    </>
  );
};

export default EmployerPanel;
